import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	warningDialogTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '20px 24px 16px',
	},
	headerSpacer: {
		flexGrow: 1,
	},
} satisfies Record<string, CSSObject>);
